import { createElement, CSSProperties, ReactHTML, ReactNode } from 'react'

import 'app/components/common/text/text.scss'

type TextProps = {
  children: ReactNode
  className?: string
  type?: keyof ReactHTML
  modifiers?: string[] | string
  style?: CSSProperties
  target?: string
  href?: string
}

// It is a set of all possible text modifiers
const modifiersSet = new Set(['underline', 'bold', 'block', 'link'])

function buildClassModifier(base: string, modifiers: string[] | string) {
  let result = ''
  if (Array.isArray(modifiers)) {
    modifiers.map((modifier) => {
      if (modifiersSet.has(modifier)) result += `${base}--${modifier} `
      return result
    })
  } else if (modifiersSet.has(modifiers)) result += `${base}--${modifiers} `

  return result
}

const Text = ({
  type = 'p',
  children,
  modifiers = '',
  className,
  style,
  target,
  href,
  ...other
}: TextProps) => {
  const textModifiers = buildClassModifier('text-component', modifiers)

  return createElement(
    type,
    {
      ...other,
      style,
      className: `text-component ${textModifiers} ${className}`,
      target,
      href,
    },
    children
  )
}

export default Text
